import type { PartialUtmParameters } from '@shared/utils/utmParameters';
import { applyUtmParametersToUrl, extractUtmParametersFromUrl, mergeUtmParameters } from '@shared/utils/utmParameters';

/**
 * Adds UTM params to a guest-site URL.
 *
 * Priority: UTM params already on the URL take precedence over `defaults`.
 * Returns the input unchanged if it is empty.
 *
 * @param url - The guest-site URL (e.g. `https://withjoy.com/{handle}`)
 * @param defaults - UTM defaults applied only for keys missing from the URL
 * @returns URL with UTM params merged in (existing URL UTMs win over defaults)
 */
export const addGuestSiteUtmParams = (url: string, defaults: PartialUtmParameters): string => {
  if (!url) return url;
  const existing = extractUtmParametersFromUrl(url);
  return applyUtmParametersToUrl(url, mergeUtmParameters(existing, defaults));
};
